export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string | boolean> = {},
  children: (Node | string)[] = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v === false || v == null) continue;
    if (k.startsWith("on") && typeof v === "string") continue;
    if (typeof v === "boolean") {
      if (v) node.setAttribute(k, "");
    } else {
      node.setAttribute(k, v);
    }
  }
  for (const child of children) {
    node.appendChild(typeof child === "string" ? document.createTextNode(child) : child);
  }
  return node;
}

export function header(opts: { title: string; subtitle?: string; back?: () => void }): HTMLElement {
  const wrap = el("header", { class: "app-header" });
  if (opts.back) {
    const btn = el("button", { class: "back", "aria-label": "返回" }, ["←"]);
    btn.addEventListener("click", opts.back);
    wrap.appendChild(btn);
  }
  const text = el("div", {}, [el("h1", {}, [opts.title])]);
  if (opts.subtitle) text.appendChild(el("div", { class: "subtitle" }, [opts.subtitle]));
  wrap.appendChild(text);
  return wrap;
}

export function mount(...nodes: Node[]): void {
  const app = document.getElementById("app")!;
  app.replaceChildren(...nodes);
}

export function showToast(message: string, kind: "info" | "error" = "info"): void {
  const t = el("div", { class: `toast ${kind === "error" ? "error" : ""}` }, [message]);
  document.body.appendChild(t);
  setTimeout(() => t.remove(), 3200);
}

export function hideLoader(): void {
  const loader = document.getElementById("loader");
  const app = document.getElementById("app");
  if (loader) loader.style.display = "none";
  if (app) app.hidden = false;
}
